<script>
export default {
  name: 'VcStyle',
  render (createElement) {
    return createElement('style', this.$slots.default)
  }
}
</script>



// WEBPACK FOOTER //
// src/components-third-party/vc-style/vc-style.vue